import {createEventTypes} from '@utils';

export const APP = createEventTypes([
  'SHOW_NOTIFICATION',
  'HIDE_NOTIFICATION',
  'SHOW_LOADING',
  'HIDE_LOADING',
  'LOGGING_STATUS_CHANGE',
  'ACCOUNT_STATUS_CHANGE',
  'DISABLE_BODY_SCROLLING',
  'ENABLE_BODY_SCROLLING',
  'ENABLE_CONFIRM_BEFORE_LEAVE',
  'DISABLE_CONFIRM_BEFORE_LEAVE',
  'POP_DELAYED_NOTIFICATION',
  'PUSH_DELAYED_NOTIFICATION',
  'RELOAD_ANIMATIONS',
  'LOYALTY_MENU_NOTIFICATION',
  'LOYALTY_NOTIFICATION',
  'REFETCH_HOME_CONTENT_TITLE',
  'LEFT_NAV_OFF',
  'LEFT_NAV_ON'
]);

export const ACCOUNT = createEventTypes([
  'OPEN_LOGIN_MODAL',
  'OPEN_SIGN_IN_MODAL',
  'FETCH_ACCOUNT_DETAIL',
  'OPEN_FORGOT_PASSWORD_MODAL',
  'OPEN_PHONE_VALIDATOR_MODAL',
  'SHOW_SVC_QUERY_TRANSACTION_RESULT',
  'SHOW_SVC_QUERY_BALANCE_RESULT',
  'OPEN_INVOICE_APPLICATION_MODAL',
  'SHOW_INQUIRY_INVOICE_RESULT',
  'OPEN_PIN_CODE_MODAL'
]);

export const GA_EVENT = createEventTypes([
  'MSR_SIGN_IN_SUCCESSFUL',
  'MSR_SIGN_IN_UNSUCCESSFUL',
  'SVC_DETACH_SUCCESS',
  'SVC_DETACH_FAILURE',
  'SVC_ADD_SUCCESS',
  'SVC_ADD_FAILURE',
  'CHANGE_PHONE_SUCCESS',
  'CHANGE_PHONE_FAILURE',
  'VERIFY_PHONE_VIA_EMAIL_SUCCESS',
  'VERIFY_PHONE_VIA_EMAIL_FAILURE',
  'UPDATE_PHONE_SUCCESS',
  'UPDATE_PHONE_FAILURE',
  'CHANGE_PASSWORD_SUCCESS',
  'CHANGE_PASSWORD_FAILURE',
  'RESET_PASSWORD_SUCCESS',
  'RESET_PASSWORD_FAILURE',
  'MSR_CARD_VERIFY_SUCCESS',
  'MSR_CARD_VERIFY_FAILURE',
  'SVC_CARD_VERIFY_SUCCESS',
  'SVC_CARD_VERIFY_FAILURE',
  'ACCOUNT_CREATED_SUCCESS',
  'ACCOUNT_CREATED_FAILURE',
  'MANAGE_SVC_CAPTCHA_SUCCESS',
  'MANAGE_SVC_CAPTCHA_FAILURE',
  'SVC_INQUIRY_SUCCESS',
  'SVC_INQUIRY_FAILURE',
  'SVC_INQUIRY_TRANSACTION_SUCCESS',
  'SVC_INQUIRY_TRANSACTION_FAILURE',
  'APPLY_INVOICE_SUCCESS',
  'APPLY_INVOICE_FAILURE',
  'QUERY_INVOICE_SUCCESS',
  'QUERY_INVOICE_FAILURE',
  'REGISTE_FIRST_STEP',
  'REGISTE_SECOND_STEP',
  'REGISTE_SUCCESS',
  'STORE_CITY_FILTER',
  'STORE_AMENITY_FILTER',
  'MSR_APP_SIGN_IN_SCAN_SUCCESSFUL',
  'MSR_APP_SIGN_IN_CONFIRMED',
  'MSR_APP_SIGN_IN_EXPIRED',
  'MSR_APP_SIGN_IN_SUCCESSFUL',
  'MSR_APP_SIGN_IN_UNSUCCESSFUL',
  'SWITCH_STAR_TYPE',
  'REDEEM_STARS_SUCCESSFUL',
  'REDEEM_STARS_UNSUCCESSFUL',
  'UPDATE_PROFILE_SUCCESSFUL',
  'UPDATE_PROFILE_UNSUCCESSFUL',
  'CHANGE_USERNAME_SUCCESSFUL',
  'CHANGE_USERNAME_UNSUCCESSFUL',
  'CHANGE_EMAIL_SUCCESSFUL',
  'CHANGE_EMAIL_UNSUCCESSFUL',
]);
